import React from 'react';

// Mobx
import { inject, observer } from 'mobx-react';

// Router
import { Link } from 'react-router-dom';

// Helpers
import Helpers from '../../helpers';

// Icons
import 'font-awesome/css/font-awesome.min.css';

// Components
import FunctionalButton from '../../components/Buttons/FunctionalButton';

interface Features {
    children?: any;
    title?: string;
    ShoppingCartStore?: any;
    StoreStore?: any;
    AppStore?: any;
    LanguageStore?: any;
    ProductCategoryStore?: any;
    visibleCategories?: boolean;
}

@inject('AuthStore', 'ShoppingCartStore', 'StoreStore', 'AppStore', 'LanguageStore', 'ProductCategoryStore')
@observer

class CommerceLayout extends React.Component<Features> {
    state: any = {
        device: 'unknown',
        isMenuOpen: null,
        activeSubmenu: null
    };

    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {
        this.detectDevice(); // İlk yüklemede cihazı algıla
        window.addEventListener('resize', this.detectDevice);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.detectDevice);
    }

    detectDevice = () => {
        const width = window.innerWidth;
        let deviceType = 'unknown';

        if (width < 768) {
            deviceType = 'mobile';
        } else if (width >= 768 && width < 1024) {
            deviceType = 'tablet';
        } else {
            deviceType = 'desktop';
        }

        this.setState({ device: deviceType });
    };

    toggleMenu = () => {
        this.setState((prevState: any) => ({
            isMenuOpen: !prevState.isMenuOpen,
            activeSubmenu: null, // Menü kapandığında alt menüleri sıfırla
        }));
    };

    toggleSubmenu = (submenu: any) => {
        this.setState((prevState: any) => ({
            activeSubmenu: prevState.activeSubmenu === submenu ? null : submenu,
        }));
    };

    render() {
        const storeId: any = localStorage.getItem('storeId');
        const storeData = this.props.StoreStore.stores[storeId];
        const visibleCategories = this.props.visibleCategories !== undefined ? this.props.visibleCategories : true;

        const shoppingCardData = Helpers.objectToArray(this.props.ShoppingCartStore.shoppingCarts)
            .filter((shoppingCard: any) => {
                return shoppingCard.store.data.id === parseInt(storeId)
            })
            .map((shoppingCard: any, index: number) => {
                return shoppingCard;
            });

        let headerLogoStyle: any = {};
        let footerLogoStyle: any = {};

        if (this.state.device !== "unknown") {
            if (this.state.device === "mobile") {
                headerLogoStyle = { width: storeData.mobile_header_logo_width }
                footerLogoStyle = { width: storeData.mobile_footer_logo_width }
            }

            if (this.state.device === "tablet") {
                headerLogoStyle = { width: storeData.tablet_header_logo_width }
                footerLogoStyle = { width: storeData.tablet_footer_logo_width }
            }

            if (this.state.device === "desktop") {
                headerLogoStyle = { width: storeData.desktop_header_logo_width }
                footerLogoStyle = { width: storeData.desktop_footer_logo_width }
            }
        }

        const { isMenuOpen, activeSubmenu } = this.state;

        const returnLink = (text: string, to: string, className: string, newTab: boolean = false) => {
            return (
                newTab ?
                    <Link
                        to={to}
                        className={className}
                        target="_blank"
                    >
                        {Helpers.translation(text)}
                    </Link>
                    :
                    <Link
                        to={to}
                        className={className}
                    >
                        {Helpers.translation(text)}
                    </Link>
            )
        }

        return (
            <div className="relative">
                {
                    this.props.AppStore.loadingStatus ?
                        <div className="w-full h-screen absolute z-10 flex justify-center items-center">
                            <div className="relative z-10 flex flex-col items-center justify-center px-4">
                                <div>{Helpers.translation('upload/create-record-please-wait')}</div>
                                <div>{this.props.AppStore.loadingPercent}%</div>
                            </div>

                            <div className="absolute w-full h-full bg-white opacity-80"></div>
                        </div>
                        :
                        this.props.AppStore.transactionStatus &&
                        <div className="w-full h-screen absolute z-10 flex justify-center items-center">
                            <div className="relative z-10 flex flex-col items-center justify-center px-4">
                                <div>{Helpers.translation('processing-in-progress')}</div>
                            </div>

                            <div className="absolute w-full h-full bg-white opacity-80"></div>
                        </div>
                }

                <div className={`relative overflow-hidden ${this.props.AppStore.transactionStatus ? "h-screen" : ""}`}>
                    <div className="relative xl:hidden bg-gray-dark flex flex-row justify-between p-2">
                        <Link to="/home">
                            <img
                                src={Helpers.getSmallestImageUrl(storeData.desktop_header_logo.data.attributes)}
                                alt="Logo"
                                style={headerLogoStyle}
                            />
                        </Link>

                        <button
                            className="text-white rounded-md hover:bg-blue-600 font-bold"
                            onClick={this.toggleMenu}
                        >
                            Menü
                        </button>
                    </div>

                    <div className="relative xl:hidden bg-gray-dark">
                        <div
                            className={`fixed top-0 left-0 z-20 h-full bg-gray-dark text-white w-64 shadow-lg transform ${isMenuOpen ? "translate-x-0" : "-translate-x-full"
                                } transition-transform duration-300`}
                        >
                            <div className="p-2 border-b border-gray-700 flex justify-between items-center">
                                <h2 className="text-lg font-bold">{Helpers.translation('menu')}</h2>
                                <button
                                    className="text-gray-400 hover:text-white"
                                    onClick={this.toggleMenu}
                                >
                                    ✕
                                </button>
                            </div>

                            <ul className="p-4 space-y-4">
                                {
                                    storeData.desktop_header_menu
                                        .filter((headerMenu: any) => {
                                            return headerMenu.menu.data !== null && Helpers.menuVisibleStatus(headerMenu.menu.data.attributes.visible);
                                        })
                                        .map((headerMenu: any, index: number) => {
                                            const menuData = Helpers.returnMenuLink(headerMenu.menu.data.attributes);

                                            if (headerMenu.menu.data !== null) {
                                                if (headerMenu.menu.data.attributes.child_menus.data.length >= 1) {
                                                    return (
                                                        <li key={index}>
                                                            <button
                                                                className="w-full text-left flex justify-between items-center p-2 rounded-lg hover:bg-gray-700"
                                                                onClick={() => this.toggleSubmenu(headerMenu.id)}
                                                            >
                                                                {Helpers.translation(headerMenu.menu.data.attributes.title)}
                                                                <span>{activeSubmenu === headerMenu.id ? "−" : "+"}</span>
                                                            </button>

                                                            {activeSubmenu === headerMenu.id && (
                                                                <ul className="ml-4 mt-2 space-y-2">
                                                                    {
                                                                        headerMenu.menu.data.attributes.child_menus.data
                                                                            .filter((menu: any) => {
                                                                                return Helpers.menuVisibleStatus(menu.attributes.visible);
                                                                            })
                                                                            .map((child: any, childIndex: number) => {
                                                                                const childMenuData = Helpers.returnMenuLink(child.attributes, "child");

                                                                                return (
                                                                                    <li
                                                                                        key={childIndex}
                                                                                        className="py-1 px-3 rounded-lg hover:bg-gray-600"
                                                                                        onClick={() => this.toggleMenu()}
                                                                                    >
                                                                                        {returnLink(Helpers.translation(child.attributes.title), childMenuData.returnLink, "", childMenuData.newTab)}
                                                                                    </li>
                                                                                )
                                                                            })
                                                                    }
                                                                </ul>
                                                            )}
                                                        </li>
                                                    )
                                                } else {
                                                    return (
                                                        <li
                                                            key={index}
                                                            onClick={() => this.toggleMenu()}
                                                            className="hover:bg-gray-700 p-2 rounded-lg"
                                                        >
                                                            {returnLink(Helpers.translation(headerMenu.menu.data.attributes.title), menuData.returnLink, "hover:text-secondary font-semibold", menuData.newTab)}
                                                        </li>
                                                    )
                                                }
                                            }
                                        })
                                }

                                {
                                    storeData.product_categories.data
                                        .map((category: any, index: number) => {
                                            const categoryData = this.props.ProductCategoryStore.productCategories[category.id];

                                            return (
                                                <li
                                                    key={index}
                                                    onClick={() => this.toggleMenu()}
                                                    className="hover:bg-gray-700 p-2 rounded-lg"
                                                >
                                                    <Link
                                                        key={index}
                                                        to={`/products/category/${categoryData.id}`}
                                                        className="font-bold"
                                                    >
                                                        {categoryData.title}
                                                    </Link>
                                                </li>
                                            )
                                        })
                                }
                            </ul>
                        </div>

                        {isMenuOpen && (
                            <div
                                className="fixed inset-0 bg-black bg-opacity-50 z-10"
                                onClick={this.toggleMenu}
                            ></div>
                        )}
                    </div>

                    <header className="bg-gray-dark sticky top-0 z-50 hidden xl:block">
                        <div className="flex flex-row container mx-auto py-4 items-center">
                            {/* Left section: Logo */}
                            <Link
                                to="/home"
                                className="flex items-center w-2/12"
                            >
                                <div>
                                    <img
                                        src={Helpers.getSmallestImageUrl(storeData.desktop_header_logo.data.attributes)}
                                        alt="Logo"
                                        style={headerLogoStyle}
                                    />
                                </div>
                            </Link>

                            {/* Center section: Menu */}
                            <nav className="hidden xl:flex md:flex-grow justify-center w-9/12">
                                <ul className="flex flex-row items-center justify-center space-x-4 text-white">
                                    {
                                        storeData.desktop_header_menu
                                            .filter((headerMenu: any) => {
                                                return headerMenu.menu.data !== null && Helpers.menuVisibleStatus(headerMenu.menu.data.attributes.visible);
                                            })
                                            .map((headerMenu: any, index: number) => {
                                                const menuData = Helpers.returnMenuLink(headerMenu.menu.data.attributes);

                                                if (headerMenu.menu.data !== null) {
                                                    if (headerMenu.menu.data.attributes.child_menus.data.length >= 1) {
                                                        return (
                                                            <li
                                                                key={index}
                                                                className="relative group text-base cursor-pointer"
                                                            >
                                                                <div className="hover:text-secondary font-semibold flex items-center">
                                                                    {Helpers.translation(headerMenu.menu.data.attributes.title)}
                                                                    <i className="fa fa-chevron-down ml-1 text-xs"></i>
                                                                </div>

                                                                <ul className="opacity-0 group-hover:opacity-100 transform scale-95 group-hover:scale-100 absolute left-0 bg-white text-black space-y-2 mt-1 p-2 rounded shadow-lg transition-all duration-300 delay-150">
                                                                    {
                                                                        headerMenu.menu.data.attributes.child_menus.data
                                                                            .filter((menu: any) => {
                                                                                return Helpers.menuVisibleStatus(menu.attributes.visible);
                                                                            })
                                                                            .map((child: any, childIndex: number) => {
                                                                                const childMenuData = Helpers.returnMenuLink(child.attributes, "child");

                                                                                return (
                                                                                    <li key={childIndex}>
                                                                                        {returnLink(Helpers.translation(child.attributes.title), childMenuData.returnLink, "min-w-40 block px-4 py-2 hover:bg-primary hover:text-white rounded", childMenuData.newTab)}
                                                                                    </li>
                                                                                )
                                                                            })
                                                                    }
                                                                </ul>
                                                            </li>
                                                        )
                                                    } else {
                                                        return (
                                                            <li
                                                                className="text-base"
                                                                key={index}
                                                            >
                                                                {returnLink(Helpers.translation(headerMenu.menu.data.attributes.title), menuData.returnLink, "hover:text-secondary font-semibold", menuData.newTab)}
                                                            </li>
                                                        )
                                                    }
                                                }
                                            })
                                    }
                                </ul>
                            </nav>

                            {/* Right section: Buttons (for desktop) */}
                            <div className="hidden xl:flex items-center justify-end space-x-4 relative w-1/12">
                                <div className="relative group cart-wrapper cursor-pointer">
                                    <img
                                        src={require("../../assets/images/cart-shopping.svg").default}
                                        alt="Cart"
                                        className="h-6 w-6 group-hover:scale-120"
                                    />

                                    {/* Cart dropdown */}
                                    <div className="opacity-0 group-hover:opacity-100 transform scale-95 group-hover:scale-100 flex flex-col absolute right-0 mt-1 w-80 bg-white shadow-lg p-4 rounded transition-all duration-300 delay-150 pointer-events-none group-hover:pointer-events-auto">
                                        {
                                            shoppingCardData.length >= 1 ?
                                                <>
                                                    {
                                                        shoppingCardData.map((shoppingCart: any, index: number) => {
                                                            const productData = {
                                                                id: shoppingCart.product.data.id,
                                                                ...shoppingCart.product.data.attributes
                                                            };

                                                            const convertCurrencyData = Helpers.convertCurrencyData(productData.currency);

                                                            let totalCurrencyPrice = convertCurrencyData !== null ? Helpers.returnPrice(productData.id, {
                                                                price: productData.price,
                                                                ...convertCurrencyData
                                                            }, shoppingCart.quantity) : null

                                                            const mainImage: any = productData.main_image.data !== null ? Helpers.getSmallestImageUrl(productData.main_image.data.attributes) : null;

                                                            return (
                                                                <div
                                                                    key={index}
                                                                    className="mt-3"
                                                                >
                                                                    <div className="flex items-center justify-between pb-4 border-b border-gray-line">
                                                                        <div className="flex items-center">
                                                                            {
                                                                                mainImage !== null ?
                                                                                    <img
                                                                                        src={mainImage}
                                                                                        alt="Product"
                                                                                        className="h-12 w-12 object-cover rounded mr-2"
                                                                                    />
                                                                                    :
                                                                                    <img
                                                                                        src={require("../../assets/images/no-image.png")}
                                                                                        alt="Product"
                                                                                        className="h-12 w-12 object-cover rounded mr-2"
                                                                                    />
                                                                            }
                                                                            <div>
                                                                                <p className="font-semibold">{Helpers.truncateText(productData.title, 15)}</p>
                                                                                <p className="text-sm">{shoppingCart.quantity + ' ' + productData.product_unit.data.attributes.title}</p>
                                                                            </div>
                                                                        </div>
                                                                        {
                                                                            totalCurrencyPrice.discountPrice > 0 ?
                                                                                <div>
                                                                                    <p className="text-lg font-semibold">{Helpers.multiplyStringNumber(totalCurrencyPrice.discountPrice, 1) + '' + totalCurrencyPrice.symbol}</p>
                                                                                    <p className="text-sm font-semibold line-through">{Helpers.multiplyStringNumber(totalCurrencyPrice.onlyPrice, 1) + '' + totalCurrencyPrice.symbol}</p>
                                                                                </div>
                                                                                :
                                                                                <div>
                                                                                    <p className="text-lg font-semibold">{Helpers.multiplyStringNumber(totalCurrencyPrice.onlyPrice, 1) + '' + totalCurrencyPrice.symbol}</p>
                                                                                </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }

                                                    <Link to="/shoppingcard">
                                                        <FunctionalButton
                                                            text={Helpers.translation('go_to_card')}
                                                            customClasses="mt-4"
                                                            rounded
                                                        />
                                                    </Link>
                                                </>
                                                :
                                                <div>
                                                    {Helpers.translation('you-shopping-cart-null-text')}
                                                </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>

                    {
                        visibleCategories &&
                        storeData.product_categories.data !== null &&
                        <header className="sticky top-0 hidden lg:block z-0">
                            <div className="grid grid-cols-10 container mx-auto mt-4">
                                {
                                    storeData.product_categories.data
                                        .map((category: any, index: number) => {
                                            const categoryData = this.props.ProductCategoryStore.productCategories[category.id];

                                            return (
                                                <Link
                                                    key={index}
                                                    to={`/products/category/${categoryData.id}`}
                                                >
                                                    <div className="flex flex-col justify-between items-center">
                                                        {
                                                            categoryData.image.data !== null ?
                                                                <img
                                                                    src={Helpers.getBiggestImageUrl(categoryData.image.data.attributes)}
                                                                    className="w-20 h-20 object-contain relative z-0"
                                                                />
                                                                :
                                                                <img
                                                                    src={require("../../assets/images/no-image.png")}
                                                                    className="w-full h-20 object-contain relative z-0"
                                                                />
                                                        }

                                                        <div className={`w-full flex flex-col justify-center text-center lg:text-xs xl:text-sm font-bold mt-2 h-10 border-r ${index === 0 && 'border-l'}`}>
                                                            {categoryData.title}
                                                        </div>
                                                    </div>
                                                </Link>
                                            )
                                        })
                                }
                            </div>
                        </header>
                    }

                    {this.props.children}

                    <footer className="border-t border-gray-line">
                        <div className="container mx-auto px-4 py-10">
                            <div className="flex flex-col lg:flex-row justify-between -mx-4">
                                <div className="w-full grid grid-cols-2 md:grid-cols-4">
                                    {
                                        storeData.desktop_footer_menu.map((footerMenu: any, index: number) => {
                                            return (
                                                <div
                                                    className="w-full px-4 mb-8"
                                                    key={index}
                                                >
                                                    <h3 className="text-lg font-semibold mb-4">{footerMenu.title}</h3>
                                                    <ul>
                                                        {
                                                            footerMenu.menus.data
                                                                .filter((menu: any) => {
                                                                    return Helpers.menuVisibleStatus(menu.attributes.visible);
                                                                })
                                                                .map((menu: any, menuIndex: number) => {
                                                                    const menuData = Helpers.returnMenuLink(menu.attributes, "child");

                                                                    return (
                                                                        <li key={menuIndex}>
                                                                            {returnLink(Helpers.translation(menu.attributes.title), menuData.returnLink, "hover:text-primary", menuData.newTab)}
                                                                        </li>
                                                                    )
                                                                })
                                                        }
                                                    </ul>
                                                </div>
                                            )
                                        })
                                    }
                                </div>

                                <div className="w-full sm:w-2/6 px-4 mb-8">
                                    <h3 className="text-lg font-semibold mb-4">{storeData.footer_title}</h3>

                                    <p>
                                        <img
                                            src={Helpers.getSmallestImageUrl(storeData.desktop_footer_logo.data.attributes)}
                                            alt="Logo"
                                            className={`mb-4`}
                                            style={footerLogoStyle}
                                        />
                                    </p>

                                    <div dangerouslySetInnerHTML={{ __html: storeData.footer_text }} />

                                    <div className="w-full mt-2">
                                        <select
                                            className="border-2 border-gray-300 w-4/12 rounded p-2"
                                            value={this.props.LanguageStore.getLanguageData().currentLanguage}
                                            onChange={(value: any) => Helpers.setLanguage(value.target.value)}
                                        >
                                            {
                                                Helpers.getSelectBoxLanguageItems().map((option: any, index: number) => {
                                                    return (
                                                        <option
                                                            key={index}
                                                            value={option.value}
                                                        >
                                                            {option.label}
                                                        </option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="py-6 border-t border-gray-line">
                            <div className="container mx-auto px-4 flex flex-wrap justify-between items-center">
                                <div className="w-full lg:w-3/4 text-center lg:text-left mb-4 lg:mb-0">
                                    <p className="mb-2" dangerouslySetInnerHTML={{ __html: storeData.under_text }}></p>
                                </div>
                            </div>
                        </div>
                    </footer>
                </div>
            </div>
        )
    }
}

export default CommerceLayout;